(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.lp-pdp-main');
    if (!section) return;

    /** Variant data rendered by lp-pdp-product-form-default. */
    let variantData = [];
    const variantDataEl = section.querySelector('#lp-variant-data');
    if (variantDataEl) {
      try {
        variantData = JSON.parse(variantDataEl.textContent);
      } catch (e) {
        variantData = [];
      }
    }

    function getVariantMediaId(variant) {
      return variant && variant.featured_media && variant.featured_media.id != null
        ? variant.featured_media.id
        : null;
    }

    // ============ Lightbox Variables ============
    let allImages = [];
    let currentImageIndex = 0;

    // ============ Main Image Update Function ============
    const mainImage = section.querySelector('#lp-main-img');

    /**
     * Resolves the main image URL to match #lp-main-img width (1000w) when the slide exists in the gallery,
     * so swaps reuse the same URL we prefetch and avoid an extra CDN fetch for a different resize.
     */
    function getMainImageUrlForVariant(variant) {
      if (!variant) {
        return null;
      }

      const mediaId = getVariantMediaId(variant);

      if (mediaId != null) {
        const slideImg = section.querySelector(
          '.lp-pdp__swiper-slide img[data-media-id="' + mediaId + '"]'
        );
        if (slideImg) {
          const mainSrc = slideImg.getAttribute('data-main-src');
          if (mainSrc) {
            return mainSrc;
          }
        }
      }

      if (variant.featured_image && variant.featured_image.src) {
        return variant.featured_image.src;
      }
      if (
        variant.featured_media &&
        variant.featured_media.preview_image &&
        variant.featured_media.preview_image.src
      ) {
        return variant.featured_media.preview_image.src;
      }
      return null;
    }

    /** Preload main-size images for every gallery slide so the first swatch change hits cache after refresh. */
    function prefetchMainImagesForSwatches() {
      const seen = new Set();
      const slideImages = section.querySelectorAll('.lp-pdp__swiper-slide img[data-main-src]');
      for (const img of slideImages) {
        const url = img.getAttribute('data-main-src');
        if (url && !seen.has(url)) {
          seen.add(url);
          const pre = new Image();
          pre.src = url;
        }
      }
    }

    function updateMainImage(imageSrc) {
      if (mainImage && imageSrc) {
        mainImage.src = imageSrc;
      }
    }

    // ============ Initialize All Images ============
    function initializeAllImages() {
      // We only collect from swiper to avoid duplicates from thumbnail grid,
      // as they contain identical images but at different resolution sizes.
      const swiperImages = Array.from(section.querySelectorAll('.lp-pdp__swiper-slide img'));
      
      allImages = [];
      
      swiperImages.forEach(img => {
        if (img.src) {
          allImages.push(img.src);
        }
      });

      // If no images found, try to get from featured image
      if (allImages.length === 0 && mainImage) {
        allImages.push(mainImage.src);
      }
    }

    // ============ Lightbox Functions ============
    const lightbox = section.querySelector('#lp-lightbox');
    const lightboxTrack = section.querySelector('#lp-lightbox-track');
    const lightboxClose = section.querySelector('#lp-lightbox-close');
    const lightboxPrev = section.querySelector('#lp-lightbox-prev');
    const lightboxNext = section.querySelector('#lp-lightbox-next');
    const lightboxOverlay = section.querySelector('.lp-pdp__lightbox-overlay');
    const lightboxDotsContainer = section.querySelector('#lp-lightbox-dots');

    function createLightboxDots() {
      if (!lightboxDotsContainer) return;
      
      lightboxDotsContainer.innerHTML = '';
      allImages.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.className = 'lp-pdp__lightbox-dot';
        if (index === currentImageIndex) {
          dot.classList.add('lp-pdp__lightbox-dot--active');
        }
        dot.addEventListener('click', (e) => {
          e.stopPropagation();
          currentImageIndex = index;
          if (lightboxTrack) {
            lightboxTrack.style.transition = 'transform 0.3s ease-out';
            lightboxTrack.style.transform = `translate3d(-${currentImageIndex * 100}%, 0, 0)`;
          }
          updateLightboxControls();
        });
        lightboxDotsContainer.appendChild(dot);
      });
    }

    function createLightboxImages() {
      if (!lightboxTrack) return;
      lightboxTrack.innerHTML = '';
      allImages.forEach((src) => {
        const img = document.createElement('img');
        img.className = 'lp-pdp__lightbox-image';
        img.src = src;
        img.alt = 'Product image';
        img.style.flex = '0 0 100%';
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'contain';
        img.draggable = false;
        lightboxTrack.appendChild(img);
      });
    }

    function openLightboxAtIndex(index) {
      if (index < 0 || index >= allImages.length) return;
      
      currentImageIndex = index;
      createLightboxImages();
      
      if (lightboxTrack) {
        lightboxTrack.style.transition = 'none';
        lightboxTrack.style.transform = `translate3d(-${currentImageIndex * 100}%, 0, 0)`;
      }

      lightbox.classList.add('lp-pdp__lightbox--active');
      updateLightboxControls();
      createLightboxDots();
    }

    function closeLightbox() {
      lightbox.classList.remove('lp-pdp__lightbox--active');
    }

    function updateLightboxControls() {
      // Disable/Enable prev arrow
      if (lightboxPrev) {
        lightboxPrev.disabled = currentImageIndex === 0;
      }
      
      // Disable/Enable next arrow
      if (lightboxNext) {
        lightboxNext.disabled = currentImageIndex === allImages.length - 1;
      }

      // Update active dot
      const dots = lightboxDotsContainer.querySelectorAll('.lp-pdp__lightbox-dot');
      dots.forEach((dot, index) => {
        if (index === currentImageIndex) {
          dot.classList.add('lp-pdp__lightbox-dot--active');
        } else {
          dot.classList.remove('lp-pdp__lightbox-dot--active');
        }
      });
    }

    function nextImage() {
      if (currentImageIndex < allImages.length - 1) {
        currentImageIndex++;
        if (lightboxTrack) {
          lightboxTrack.style.transition = 'transform 0.3s ease-out';
          lightboxTrack.style.transform = `translate3d(-${currentImageIndex * 100}%, 0, 0)`;
        }
        updateLightboxControls();
      }
    }

    function prevImage() {
      if (currentImageIndex > 0) {
        currentImageIndex--;
        if (lightboxTrack) {
          lightboxTrack.style.transition = 'transform 0.3s ease-out';
          lightboxTrack.style.transform = `translate3d(-${currentImageIndex * 100}%, 0, 0)`;
        }
        updateLightboxControls();
      }
    }

    // Lightbox event listeners
    if (lightboxClose) {
      lightboxClose.addEventListener('click', (e) => {
        e.stopPropagation();
        closeLightbox();
      });
    }

    // Close when clicking on overlay or any empty space in lightbox
    if (lightbox) {
      lightbox.addEventListener('click', (e) => {
        // Prevent closing if we click the wrapper/track, arrows, or pagination dots
        if (
          e.target.closest('.lp-pdp__lightbox-image-wrapper') ||
          e.target.closest('#lp-lightbox-track') ||
          e.target.closest('.lp-pdp__lightbox-arrow') ||
          e.target.closest('.lp-pdp__lightbox-pagination')
        ) {
          return;
        }
        
        closeLightbox();
      });
    }

    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', (e) => {
        e.stopPropagation();
        prevImage();
      });
    }

    if (lightboxNext) {
      lightboxNext.addEventListener('click', (e) => {
        e.stopPropagation();
        nextImage();
      });
    }

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('lp-pdp__lightbox--active')) return;
      
      if (e.key === 'Escape') {
        closeLightbox();
      } else if (e.key === 'ArrowLeft') {
        prevImage();
      } else if (e.key === 'ArrowRight') {
        nextImage();
      }
    });

    // Touch and Drag (Swipe) navigation
    let touchStartX = 0;
    let touchCurrentX = 0;
    let isDragging = false;
    let trackWidth = 0;

    const setDragPosition = (x) => {
      touchCurrentX = x;
      const diff = touchCurrentX - touchStartX;
      if (lightboxTrack) {
        lightboxTrack.style.transition = 'none';
        
        let newX = -(currentImageIndex * trackWidth) + diff;
        
        if (newX > 0) {
           newX = newX * 0.3; 
        } else if (newX < -(allImages.length - 1) * trackWidth) {
           const overscroll = newX - (-(allImages.length - 1) * trackWidth);
           newX = (-(allImages.length - 1) * trackWidth) + (overscroll * 0.3);
        }

        lightboxTrack.style.transform = `translate3d(${newX}px, 0, 0)`;
      }
    };

    const handleSwipeEnd = () => {
      if (!isDragging) return;
      
      const diff = touchCurrentX - touchStartX;
      const swipeThreshold = 50;

      if (diff < -swipeThreshold && currentImageIndex < allImages.length - 1) {
        currentImageIndex++;
      } else if (diff > swipeThreshold && currentImageIndex > 0) {
        currentImageIndex--;
      }

      if (lightboxTrack) {
        lightboxTrack.style.transition = 'transform 0.3s ease-out';
        lightboxTrack.style.transform = `translate3d(-${currentImageIndex * 100}%, 0, 0)`;
      }
      updateLightboxControls();
      
      isDragging = false;
    };

    if (lightbox) {
      const initDrag = (e, clientX) => {
        if (e.target.closest('.lp-pdp__lightbox-image-wrapper') || e.target.closest('#lp-lightbox-track')) {
          isDragging = true;
          touchStartX = clientX;
          const wrapper = section.querySelector('.lp-pdp__lightbox-image-wrapper');
          trackWidth = wrapper ? wrapper.offsetWidth : window.innerWidth;
          setDragPosition(touchStartX);
        }
      };

      lightbox.addEventListener('touchstart', (e) => {
        initDrag(e, e.changedTouches[0].screenX);
      }, { passive: true });

      lightbox.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        setDragPosition(e.changedTouches[0].screenX);
      }, { passive: true });

      lightbox.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        setDragPosition(e.changedTouches[0].screenX);
        handleSwipeEnd();
      }, { passive: true });

      lightbox.addEventListener('mousedown', (e) => {
        initDrag(e, e.clientX);
      });

      lightbox.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        setDragPosition(e.clientX);
      });

      lightbox.addEventListener('mouseup', (e) => {
        if (!isDragging) return;
        setDragPosition(e.clientX);
        handleSwipeEnd();
      });

      lightbox.addEventListener('mouseleave', (e) => {
        if (!isDragging) return;
        setDragPosition(e.clientX);
        handleSwipeEnd();
      });
    }

    // ============ Initialize Main Image from Selected Variant ============
    function initializeMainImage() {
      const variantSelect = section.querySelector('[name="id"]');
      if (!variantSelect || !variantData.length) return;
      const selectedVariant = variantData.find(v => String(v.id) === String(variantSelect.value));
      const url = getMainImageUrlForVariant(selectedVariant);
      if (url) {
        updateMainImage(url);
      }
    }

    // ============ Swiper Initialization ============
    function initializeSwiper() {
      const swiperContainer = section.querySelector('.lp-pdp__swiper');
      
      if (swiperContainer && window.Swiper) {
        const swiper = new Swiper(swiperContainer, {
          loop: false,
          zoom: {
            maxRatio: 3,
            toggle: true,
          },
          pagination: {
            el: section.querySelector('.lp-pdp__swiper-pagination'),
            type: 'bullets',
            clickable: true,
          },
          on: {
            slideChange: () => {
              const activeSlide = swiperContainer.querySelector('.swiper-slide-active img');
              if (activeSlide) {
                updateMainImage(activeSlide.src);
              }
            }
          }
        });
      }
    }

    // ============ Thumbnail Grid Click Handler ============
    function initializeThumbnailGrid() {
      const thumbnailItems = section.querySelectorAll('.lp-pdp__thumbnail-item');
      
      thumbnailItems.forEach((item, index) => {
        item.addEventListener('click', () => {
          const img = item.querySelector('img');
          if (img) {
            // Mark thumbnail as active for visual feedback
            item.classList.add('lp-pdp__thumbnail-item--active');
            thumbnailItems.forEach(t => {
              if (t !== item) t.classList.remove('lp-pdp__thumbnail-item--active');
            });

            // Open lightbox with the clicked image
            initializeAllImages();
            // Since thumbnail grid matches swiper index, use the index directly
            if (index < allImages.length) {
              openLightboxAtIndex(index);
            }
          }
        });
      });
    }

    // ============ Desktop: Main Image Click Opens Lightbox ============
    function initializeMainImageLightbox() {
      const mainImageContainer = section.querySelector('#lp-main-image');
      if (mainImageContainer && window.innerWidth >= 768) {
        mainImageContainer.addEventListener('click', (e) => {
          if (e.target.closest('.ada-video-pause-btn')) return;
          initializeAllImages();
          
          // Find the index of the current main image
          const currentSrc = mainImage.src;
          const getPath = (src) => {
            try { return new URL(src, window.location.origin).pathname; }
            catch(e) { return src.split('?')[0]; }
          };
          const currentPath = getPath(currentSrc);
          
          currentImageIndex = allImages.findIndex(src => getPath(src) === currentPath);
          if (currentImageIndex === -1) currentImageIndex = 0;
          
          openLightboxAtIndex(currentImageIndex);
        });
      }
    }

    // ============ Product form ============
    const productForm = section.querySelector('#lp-product-form');
    const variantInput = productForm ? productForm.querySelector('[name="id"]') : null;
    const optionRadios = section.querySelectorAll('.lp-pdp__option-label input[type="radio"]');
    const submitBtn = section.querySelector('[data-js-add-to-cart-btn]');
    const submitText = submitBtn ? submitBtn.querySelector('.lp-pdp__submit-text') : null;
    const errorEl = section.querySelector('[data-js-form-error]');
    const dynamicCheckout = section.querySelector('[data-js-dynamic-checkout]');
    const quantityInput = section.querySelector('[data-js-quantity-input]');

    function getVariantOptionValue(variant, optionIndex) {
      if (variant.options && Array.isArray(variant.options)) {
        return variant.options[optionIndex] || null;
      }
      if (optionIndex === 0) return variant.option1 || null;
      if (optionIndex === 1) return variant.option2 || null;
      if (optionIndex === 2) return variant.option3 || null;
      return null;
    }

    function getSelectedOptions() {
      return Array.from(
        section.querySelectorAll('.lp-pdp__option-label input[type="radio"]:checked')
      ).map(r => r.value);
    }

    function findVariantByOptions(selectedOptions) {
      return variantData.find(v =>
        selectedOptions.every((val, i) => getVariantOptionValue(v, i) === val)
      ) || null;
    }

    function getCurrentVariant() {
      if (!variantInput || !variantData.length) return null;
      return variantData.find(v => String(v.id) === String(variantInput.value)) || null;
    }

    // Money formatter mirroring Liquid's `money` filter using the shop's money format.
    function formatMoney(cents) {
      const format = section.dataset.moneyFormat || '${{amount}}';
      const value = Number(cents) || 0;
      const withDelimiters = (amount, decimals, thousands, decimal) => {
        const fixed = (amount / 100).toFixed(decimals).split('.');
        const whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return fixed[1] ? whole + decimal + fixed[1] : whole;
      };
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
        switch (key) {
          case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
          case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return withDelimiters(value, 2, "'", '.');
          case 'amount_with_space_separator': return withDelimiters(value, 2, ' ', ',');
          default: return withDelimiters(value, 2, ',', '.');
        }
      });
    }

    function setError(message) {
      if (errorEl) errorEl.textContent = message || '';
    }

    function updateButtonForVariant(variant) {
      if (!submitBtn || !submitText) return;
      const available = !!(variant && variant.available);
      submitBtn.disabled = !available;
      submitText.textContent = !variant ? 'Unavailable' : available ? 'Add to cart' : 'Sold out';
      if (dynamicCheckout) dynamicCheckout.hidden = !available;
    }

    function updatePrice(variant) {
      if (!variant) return;
      const comparePrice = variant.compare_at_price;
      const onSale = comparePrice != null && Number(comparePrice) > Number(variant.price);

      section.querySelectorAll('.lp-pdp__price-row').forEach((row) => {
        const priceEl = row.querySelector('.lp-pdp__price');
        const compareEl = row.querySelector('.lp-pdp__compare-price');
        const offEl = row.querySelector('.lp-pdp__price-off');

        if (priceEl) priceEl.textContent = formatMoney(variant.price);

        if (compareEl) {
          compareEl.hidden = !onSale;
          if (onSale) compareEl.textContent = formatMoney(comparePrice);
        }

        if (offEl) {
          const pct = onSale ? Math.round(((comparePrice - variant.price) / comparePrice) * 100) : 0;
          if (pct > 0) {
            const prefix = (offEl.getAttribute('data-off-prefix') || '').trim();
            const suffix = (offEl.getAttribute('data-off-suffix') || '').trim();
            offEl.textContent = [prefix, pct + '%', suffix].filter(Boolean).join(' ');
            offEl.hidden = false;
          } else {
            offEl.hidden = true;
          }
        }
      });
    }

    function updatePickup(variant) {
      section.querySelectorAll('[data-pickup-variant]').forEach((el) => {
        el.hidden = !variant || el.getAttribute('data-pickup-variant') !== String(variant.id);
      });
    }

    function updateUrl(variant) {
      if (!variant || !window.history?.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function updateGalleryForVariant(variant) {
      const newImageSrc = getMainImageUrlForVariant(variant);
      if (!newImageSrc) return;
      updateMainImage(newImageSrc);

      const mediaId = getVariantMediaId(variant);
      if (mediaId == null) return;
      let slideIndex = -1;
      section.querySelectorAll('.lp-pdp__swiper-slide img[data-media-id]').forEach((img, i) => {
        if (String(img.getAttribute('data-media-id')) === String(mediaId)) slideIndex = i;
      });
      const swiperContainer = section.querySelector('.lp-pdp__swiper');
      if (slideIndex !== -1 && swiperContainer && swiperContainer.swiper) {
        swiperContainer.swiper.slideTo(slideIndex);
      }
    }

    function updateOptionAvailability() {
      if (!variantData.length) return;
      const selected = getSelectedOptions();

      optionRadios.forEach((radio) => {
        const optionIndex = Number(radio.dataset.index) - 1;
        const optionLabel = radio.closest('.lp-pdp__option-label');
        if (!optionLabel || optionIndex < 0) return;

        const matchesSelection = (variant) => {
          if (getVariantOptionValue(variant, optionIndex) !== radio.value) return false;
          return selected.every((value, i) => {
            if (!value || i === optionIndex) return true;
            return getVariantOptionValue(variant, i) === value;
          });
        };

        // Hide values whose combination does not exist; cross out sold-out ones.
        const existsAtAll = variantData.some(matchesSelection);
        const inStock = variantData.some((v) => v.available && matchesSelection(v));

        optionLabel.hidden = !existsAtAll;
        optionLabel.classList.toggle('lp-pdp__option-label--unavailable', existsAtAll && !inStock);
        radio.disabled = !existsAtAll;
        if (inStock) radio.removeAttribute('aria-disabled');
        else radio.setAttribute('aria-disabled', 'true');
      });
    }

    // If the picked value makes the combination impossible, steer the other
    // option groups to the nearest real variant.
    function reconcileToValidVariant(changedRadio) {
      if (!variantData.length) return;
      const changedIndex = Number(changedRadio.dataset.index) - 1;
      if (changedIndex < 0) return;
      if (findVariantByOptions(getSelectedOptions())) return;

      const candidate =
        variantData.find(v => v.available && getVariantOptionValue(v, changedIndex) === changedRadio.value) ||
        variantData.find(v => getVariantOptionValue(v, changedIndex) === changedRadio.value);
      if (!candidate) return;

      section.querySelectorAll('.lp-pdp__option-group').forEach((group, index) => {
        if (index === changedIndex) return;
        const target = getVariantOptionValue(candidate, index);
        if (!target) return;
        const targetRadio = Array.from(group.querySelectorAll('input[type="radio"]')).find(r => r.value === target);
        if (targetRadio && !targetRadio.checked) {
          targetRadio.checked = true;
          const labelEl = section.querySelector(`[data-option-selected="${targetRadio.dataset.index}"]`);
          if (labelEl) labelEl.textContent = targetRadio.value;
        }
      });
    }

    function initializeVariantSync() {
      const initialVariant = getCurrentVariant();
      if (initialVariant) {
        updateButtonForVariant(initialVariant);
        updatePrice(initialVariant);
      }
      updateOptionAvailability();

      optionRadios.forEach((radio) => {
        radio.addEventListener('change', () => {
          const labelEl = section.querySelector(`[data-option-selected="${radio.dataset.index}"]`);
          if (labelEl) labelEl.textContent = radio.value;

          reconcileToValidVariant(radio);
          updateOptionAvailability();
          setError('');

          const variant = findVariantByOptions(getSelectedOptions());
          if (variantInput) {
            variantInput.value = variant ? variant.id : '';
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          updateButtonForVariant(variant);
          updatePickup(variant);
          if (!variant) return;
          updatePrice(variant);
          updateGalleryForVariant(variant);
          updateUrl(variant);
        });
      });
    }

    // ============ Quantity ============
    function initializeQuantity() {
      if (!quantityInput) return;
      const minus = section.querySelector('[data-js-quantity-minus]');
      const plus = section.querySelector('[data-js-quantity-plus]');

      const getQty = () => Math.max(1, parseInt(quantityInput.value, 10) || 1);
      const sync = () => {
        quantityInput.value = getQty();
        if (minus) minus.disabled = getQty() <= 1;
      };

      if (minus) minus.addEventListener('click', () => { quantityInput.value = getQty() - 1; sync(); });
      if (plus) plus.addEventListener('click', () => { quantityInput.value = getQty() + 1; sync(); });
      quantityInput.addEventListener('change', sync);
      sync();
    }

    // ============ Add to cart ============
    function initializeFormSubmission() {
      if (!productForm || !submitBtn || !submitText) return;

      productForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (submitBtn.disabled) return;

        const variantId = variantInput ? Number(variantInput.value) : 0;
        if (!variantId) return;

        const quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;
        const body = { items: [{ id: variantId, quantity }] };
        const originalLabel = submitText.textContent;

        setError('');
        submitBtn.disabled = true;
        submitBtn.classList.add('lp-pdp__submit-btn--loading');
        submitText.innerHTML =
          '<span class="lp-pdp__loading-dots"><span class="lp-pdp__loading-dot"></span><span class="lp-pdp__loading-dot"></span><span class="lp-pdp__loading-dot"></span></span>';

        try {
          if (typeof window.lpPdpFastCartAdd === 'function') {
            await window.lpPdpFastCartAdd(body);
          } else if (typeof window.liquidAjaxCart?.add === 'function') {
            await new Promise((resolve, reject) => {
              window.liquidAjaxCart.add(body, {
                lastCallback: (state) => (state?.responseData?.ok ? resolve() : reject(new Error('Cart add failed'))),
              });
            });
          } else {
            productForm.submit();
            return;
          }
          submitText.textContent = originalLabel;
        } catch (error) {
          setError(error && error.message ? error.message : 'Could not add to cart. Please try again.');
          submitText.textContent = originalLabel;
        } finally {
          submitBtn.classList.remove('lp-pdp__submit-btn--loading');
          updateButtonForVariant(getCurrentVariant());
        }
      });
    }

    // ============ Initialize Everything ============
    prefetchMainImagesForSwatches();
    initializeMainImage();
    initializeSwiper();
    initializeThumbnailGrid();
    initializeMainImageLightbox();
    initializeVariantSync();
    initializeQuantity();
    initializeFormSubmission();
  });
})();
